import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useFirmReportSummary } from '../../../api/coreData'
import { useFormattingContext } from '../FormattingProvider/FormattingContext'
import { useDenaliFilter } from './filters/DenaliFilterContextProvider'

function replaceObjectPaths (str, obj, defaultValue = '', formatter = null, format = null) {
  str = str || ''
  return str.replace(/{{(.*?)}}/g, (match, path) => {
    const parts = path.split('.')
    let currentObj = obj
    for (let i = 0; i < parts.length - 1; i++) {
      if (!currentObj[parts[i]]) {
        // Default to an empty string when property not found
        return defaultValue
      }
      currentObj = currentObj[parts[i]]
    }

    const value = currentObj[parts.pop()] || defaultValue
    if (formatter && format) {
      return formatter(value, format)
    }

    return value
  })
}

function MetricTemplate ({ reportId, text, className, style, format }) {
  const { membershipFilter, filter } = useDenaliFilter()
  const { data, isLoading } = useFirmReportSummary(reportId, { membershipFilter, filters: filter })
  const { formatter } = useFormattingContext()

  const value = useMemo(() => {
    if (!data?.summary?.length) return null
    const dv = data.summary.reduce((p, c) => {
      p[c.key] = c
      return p
    }, {})
    return replaceObjectPaths(text, dv, '', formatter, format)
  }, [data, text, formatter, format])

  if (isLoading) {
    return null
  }
  return (
    <span className={className} style={style}>
      {value}
    </span>
  )
}

MetricTemplate.propTypes = {
  reportId: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  format: PropTypes.string
}

export default MetricTemplate
